/**
 * VoiceWave Customizer - High Resolution Zoom & Lightbox Inspection
 */
(function() {
  function initLightbox() {
    const root = document.querySelector('#vm-builder');
    if (!root) return;

    const dialog = root.querySelector('[data-vm-lightbox]');
    if (!dialog) return;

    const img = dialog.querySelector('[data-lightbox-img]');
    const wrap = dialog.querySelector('[data-lightbox-wrap]');
    const viewport = dialog.querySelector('[data-lightbox-viewport]');
    const zoomVal = dialog.querySelector('[data-lightbox-zoom-val]');
    const zoomInBtn = dialog.querySelector('[data-lightbox-zoom-in]');
    const zoomOutBtn = dialog.querySelector('[data-lightbox-zoom-out]');
    const resetBtn = dialog.querySelector('[data-lightbox-zoom-reset]');
    const closeBtns = dialog.querySelectorAll('[data-lightbox-close]');
    const zoomStageBtn = root.querySelector('[data-stage-zoom-btn]');

    let scale = 1;
    let translateX = 0;
    let translateY = 0;
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let lastTouchDist = 0;

    function getActiveStageImageSrc() {
      // 1. Check Step 4 Product View
      const productPanel = root.querySelector('.vm-product-panel:not([hidden])');
      if (productPanel) {
        const prodImg = productPanel.querySelector('[data-product-asset]');
        if (prodImg && (prodImg.currentSrc || prodImg.src)) return prodImg.currentSrc || prodImg.src;
      }

      // 2. Check Step 4 Production Proof
      const proofPanel = root.querySelector('.vm-proof-panel:not([hidden])');
      if (proofPanel) {
        const proofImg = proofPanel.querySelector('[data-production-proof]');
        if (proofImg && (proofImg.currentSrc || proofImg.src)) return proofImg.currentSrc || proofImg.src;
      }

      // 3. Check Active Carousel Slide (Slide 1~5 Sample Photos)
      const activeSlide = root.querySelector('.vm-slide-item.is-active:not([hidden])');
      if (activeSlide) {
        const slideImg = activeSlide.querySelector('.vm-sample-slide-img');
        if (slideImg && (slideImg.currentSrc || slideImg.src)) return slideImg.currentSrc || slideImg.src;
      }

      // 4. Check Step 1/2/3 Soundwave Canvas / Design Board (Slide 0)
      const waveCanvas = root.querySelector('[data-art-waveform]:not([hidden])');
      if (waveCanvas && typeof waveCanvas.toDataURL === 'function') {
        try { return waveCanvas.toDataURL('image/png'); } catch (_) {}
      }

      // 5. Fallback to any visible product/sample image
      const anyImg = root.querySelector('.vm-preview-stage img:not([hidden])');
      if (anyImg && (anyImg.currentSrc || anyImg.src)) return anyImg.currentSrc || anyImg.src;

      return '';
    }

    function updateTransform() {
      scale = Math.max(0.6, Math.min(5, scale));
      if (scale <= 1) {
        translateX = 0;
        translateY = 0;
      }
      if (wrap) {
        wrap.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
      }
      if (zoomVal) {
        zoomVal.textContent = `${Math.round(scale * 100)}%`;
      }
      if (viewport) {
        viewport.style.cursor = scale > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default';
      }
    }

    function openLightbox(specificSrc) {
      if (String(root.dataset.currentStep || '') !== '4') return;
      const src = specificSrc || getActiveStageImageSrc();
      if (!src || !img) return;

      img.src = src;
      scale = 1;
      translateX = 0;
      translateY = 0;
      updateTransform();

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      document.body.style.overflow = '';
      if (img) img.src = '';
    }

    // Zoom buttons
    if (zoomInBtn) {
      zoomInBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        scale += 0.35;
        updateTransform();
      });
    }

    if (zoomOutBtn) {
      zoomOutBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        scale -= 0.35;
        updateTransform();
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        scale = 1;
        translateX = 0;
        translateY = 0;
        updateTransform();
      });
    }

    // Close handlers
    closeBtns.forEach(btn => btn.addEventListener('click', closeLightbox));
    dialog.addEventListener('cancel', closeLightbox);

    // Click on backdrop to close
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog || e.target.hasAttribute('data-lightbox-close')) {
        closeLightbox();
      }
    });

    // Mouse wheel zoom
    if (viewport) {
      viewport.addEventListener('wheel', (e) => {
        e.preventDefault();
        const delta = e.deltaY > 0 ? -0.2 : 0.2;
        scale += delta;
        updateTransform();
      }, { passive: false });

      // Drag / pan
      viewport.addEventListener('mousedown', (e) => {
        if (e.button !== 0 || scale <= 1) return;
        isDragging = true;
        startX = e.clientX - translateX;
        startY = e.clientY - translateY;
        updateTransform();
      });

      window.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        translateX = e.clientX - startX;
        translateY = e.clientY - startY;
        updateTransform();
      });

      window.addEventListener('mouseup', () => {
        if (isDragging) {
          isDragging = false;
          updateTransform();
        }
      });

      // Double click to toggle 1x <-> 2.5x
      viewport.addEventListener('dblclick', (e) => {
        e.preventDefault();
        if (scale > 1.2) {
          scale = 1;
          translateX = 0;
          translateY = 0;
        } else {
          scale = 2.5;
        }
        updateTransform();
      });

      // Touch handling (pinch-to-zoom + pan)
      viewport.addEventListener('touchstart', (e) => {
        if (e.touches.length === 1 && scale > 1) {
          isDragging = true;
          startX = e.touches[0].clientX - translateX;
          startY = e.touches[0].clientY - translateY;
        } else if (e.touches.length === 2) {
          isDragging = false;
          const dx = e.touches[0].clientX - e.touches[1].clientX;
          const dy = e.touches[0].clientY - e.touches[1].clientY;
          lastTouchDist = Math.hypot(dx, dy);
        }
      }, { passive: true });

      viewport.addEventListener('touchmove', (e) => {
        if (e.touches.length === 1 && isDragging && scale > 1) {
          translateX = e.touches[0].clientX - startX;
          translateY = e.touches[0].clientY - startY;
          updateTransform();
        } else if (e.touches.length === 2) {
          const dx = e.touches[0].clientX - e.touches[1].clientX;
          const dy = e.touches[0].clientY - e.touches[1].clientY;
          const dist = Math.hypot(dx, dy);
          if (lastTouchDist > 0) {
            const factor = dist / lastTouchDist;
            scale *= factor;
            updateTransform();
          }
          lastTouchDist = dist;
        }
      }, { passive: true });

      viewport.addEventListener('touchend', () => {
        isDragging = false;
        lastTouchDist = 0;
      });
    }

    // Trigger button
    if (zoomStageBtn) {
      zoomStageBtn.addEventListener('click', (e) => {
        e.preventDefault();
        openLightbox();
      });
    }

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLightbox);
  } else {
    initLightbox();
  }
})();
